import { render, staticRenderFns } from "./Userorder.vue?vue&type=template&id=28ee7b30&scoped=true&"
import script from "./Userorder.vue?vue&type=script&lang=js&"
export * from "./Userorder.vue?vue&type=script&lang=js&"
import style0 from "./Userorder.vue?vue&type=style&index=0&id=28ee7b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee7b30",
  null
  
)

export default component.exports